// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cCHXr","col":"styles_col__20JDo"};